import { render, staticRenderFns } from "./LoadCssComponent.vue?vue&type=template&id=8cfd2666"
import script from "./LoadCssComponent.vue?vue&type=script&lang=js"
export * from "./LoadCssComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports